import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23.42 11.76 13.77.8A2.67 2.67 0 0 0 12 0a2.67 2.67 0 0 0-1.77.8l-9.65 11a1.41 1.41 0 1 0 2.12 1.83l7.45-8.46a.25.25 0 0 1 .28-.07.25.25 0 0 1 .16.23v17.26a1.41 1.41 0 1 0 2.82 0V5.33a.25.25 0 0 1 .16-.23.25.25 0 0 1 .28.07l7.45 8.46a1.41 1.41 0 1 0 2.12-1.87Z"
}), 'ArrowUp');